// Fenêtre de pages pour une pagination numérotée : 1 … c-1 c c+1 … n (les « … » sont des null).
export const pageWindow = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, index) => index + 1);
  const wanted = new Set([1, total, current - 1, current, current + 1]);
  const sorted = [...wanted].filter((page) => page >= 1 && page <= total).sort((a, b) => a - b);
  const result = [];
  sorted.forEach((page, index) => {
    if (index > 0 && page - sorted[index - 1] > 1) result.push(null);
    result.push(page);
  });
  return result;
};

/** « 21–40 sur 47 » ; « 0 résultat » quand la liste est vide. */
export const rangeLabel = (page, pageSize, totalItems) => {
  if (!totalItems) return '0 résultat';
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalItems);
  return `${from}–${to} sur ${totalItems}`;
};
